import { instance } from 'api/core';
import { AxiosResponse } from 'axios';

interface Response {
  token: string;
}

export function refreshToken(refreshToken: string): Promise<AxiosResponse<Response>> {
  return instance.post(`/auth/refresh-token/${refreshToken}`);
}
